import { Action } from '@ngrx/store';
import {
  BaseOneResponseInterface,
  BulkResponseDataInterface,
  GetManyResponseInterface,
} from '../../../../shared/model/interface/crud-response-interface.model';
import { IApiAutomationQueryParams } from '../shared/api-automation.model';
import {
  IHeartbeatSetting,
  IHeartbeatSettingRow,
} from '../../../../view/settings/api-automation-settings/heartbeat-settings/heartbeat-settings.model';
import { INotificationTemplate } from '../../notification-center/notification-templates/notification-templates.model';
import { NotificationGroupInterface } from '../../nofication-center/notification-groups/notification-groups.model';

export enum ActionTypes {
  HEARTBEAT_SETTINGS_DATA_LOADING = '[HEARTBEAT_SETTINGS] HEARTBEAT_SETTINGS DATA LOADING',
  HEARTBEAT_SETTINGS_DATA_LOADED = '[HEARTBEAT_SETTINGS] HEARTBEAT_SETTINGS DATA LOADED',
  GET_HEARTBEAT_SETTING = '[HEARTBEAT_SETTINGS] GET_HEARTBEAT_SETTING LOADING',
  GET_HEARTBEAT_SETTING_COMPLETED = '[HEARTBEAT_SETTINGS] GET_HEARTBEAT_SETTING COMPLETED',
  ADD_HEARTBEAT_SETTING = '[HEARTBEAT_SETTINGS] ADD_HEARTBEAT_SETTING',
  ADD_HEARTBEAT_SETTING_COMPLETED = '[HEARTBEAT_SETTINGS] ADD_HEARTBEAT_SETTING COMPLETED',
  EDIT_HEARTBEAT_SETTING = '[HEARTBEAT_SETTINGS] EDIT_HEARTBEAT_SETTING',
  EDIT_HEARTBEAT_SETTING_COMPLETED = '[HEARTBEAT_SETTINGS] EDIT_HEARTBEAT_SETTING COMPLETED',
  DELETE_HEARTBEAT_SETTINGS = '[HEARTBEAT_SETTINGS] DELETE_HEARTBEAT_SETTINGS',
  DELETE_HEARTBEAT_SETTINGS_COMPLETED = '[HEARTBEAT_SETTINGS] DELETE_HEARTBEAT_SETTINGS COMPLETED',
  MAIL_GROUPS_DATA_LOADING = '[HEARTBEAT_SETTINGS] MAIL_GROUPS DATA LOADING',
  MAIL_GROUPS_DATA_COMPLETED = '[HEARTBEAT_SETTINGS] MAIL_GROUPS DATA COMPLETED',
  MAIL_TEMPLATES_DATA_LOADING = '[HEARTBEAT_SETTINGS] MAIL_TEMPLATES DATA LOADING',
  MAIL_TEMPLATES_DATA_COMPLETED = '[HEARTBEAT_SETTINGS] MAIL_TEMPLATES DATA COMPLETED',
  FETCH_ERROR = '[HEARTBEAT_SETTINGS] FETCH ERROR',
}

export class HeartbeatSettingsLoading implements Action {
  readonly type = ActionTypes.HEARTBEAT_SETTINGS_DATA_LOADING;

  constructor(public params: IApiAutomationQueryParams) {}
}

export class HeartbeatSettingsLoaded implements Action {
  readonly type = ActionTypes.HEARTBEAT_SETTINGS_DATA_LOADED;

  constructor(public payload: GetManyResponseInterface<IHeartbeatSetting>) {}
}

export class GetHeartbeatSetting implements Action {
  readonly type = ActionTypes.GET_HEARTBEAT_SETTING;

  constructor(public recordId: number) {}
}

export class GetHeartbeatSettingCompleted implements Action {
  readonly type = ActionTypes.GET_HEARTBEAT_SETTING_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<IHeartbeatSetting>) {}
}
export class AddHeartbeatSetting implements Action {
  readonly type = ActionTypes.ADD_HEARTBEAT_SETTING;

  constructor(
    public record: IHeartbeatSettingRow,
    public hideLoaderAfterSuccess: boolean = true,
  ) {}
}

export class AddHeartbeatSettingCompleted implements Action {
  readonly type = ActionTypes.ADD_HEARTBEAT_SETTING_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<IHeartbeatSetting>) {}
}
export class EditHeartbeatSetting implements Action {
  readonly type = ActionTypes.EDIT_HEARTBEAT_SETTING;

  constructor(
    public recordId: number,
    public record: IHeartbeatSettingRow,
    public hideLoaderAfterSuccess: boolean = true,
  ) {}
}

export class EditHeartbeatSettingCompleted implements Action {
  readonly type = ActionTypes.EDIT_HEARTBEAT_SETTING_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<IHeartbeatSetting>) {}
}
export class DeleteHeartbeatSettings implements Action {
  readonly type = ActionTypes.DELETE_HEARTBEAT_SETTINGS;

  constructor(public payload: number[]) {}
}

export class DeleteHeartbeatSettingsCompleted implements Action {
  readonly type = ActionTypes.DELETE_HEARTBEAT_SETTINGS_COMPLETED;

  constructor(
    public isBulk: boolean,
    public response: BulkResponseDataInterface,
  ) {}
}
export class MailGroupsDataLoading implements Action {
  readonly type = ActionTypes.MAIL_GROUPS_DATA_LOADING;
}

export class MailGroupsDataCompleted implements Action {
  readonly type = ActionTypes.MAIL_GROUPS_DATA_COMPLETED;

  constructor(public payload: GetManyResponseInterface<Partial<NotificationGroupInterface>>) {}
}
export class MailTemplatesDataLoading implements Action {
  readonly type = ActionTypes.MAIL_TEMPLATES_DATA_LOADING;
}

export class MailTemplatesDataCompleted implements Action {
  readonly type = ActionTypes.MAIL_TEMPLATES_DATA_COMPLETED;

  constructor(public payload: GetManyResponseInterface<Partial<INotificationTemplate>>) {}
}
export class FetchError implements Action {
  readonly type = ActionTypes.FETCH_ERROR;

  constructor(public errorAction: ActionTypes) {}
}

export type HeartbeatSettingActions =
  | HeartbeatSettingsLoading
  | HeartbeatSettingsLoaded
  | GetHeartbeatSetting
  | GetHeartbeatSettingCompleted
  | AddHeartbeatSetting
  | AddHeartbeatSettingCompleted
  | EditHeartbeatSetting
  | EditHeartbeatSettingCompleted
  | DeleteHeartbeatSettings
  | DeleteHeartbeatSettingsCompleted
  | MailGroupsDataLoading
  | MailGroupsDataCompleted
  | MailTemplatesDataLoading
  | MailTemplatesDataCompleted
  | FetchError;
